import React from 'react';
import useCampagne from '../hooks/useCampagne';

// Encadré de confiance affiché en bas des pages publiques
export const TrustCard = () => {
  const { campagne } = useCampagne();
  return (
    <aside className="trust-card" aria-label="Plateforme officielle de recrutement">
      <div className="trust-icon" aria-hidden="true">🔒</div>
      <div className="trust-body">
        <h3>Plateforme officielle de recrutement</h3>
        <p>
          Ce site est la seule plateforme officielle de recrutement des coordonnateurs
          provinciaux de l'ECV 2026.
        </p>
        <p>Vos données personnelles sont chiffrées et confidentielles.</p>
        <p><strong>Aucun paiement n'est requis. Le recrutement est 100% gratuit.</strong></p>
        <p>En cas de doute, contactez directement l'INSAPT.</p>
        {campagne && (
          <div className="trust-deadline">
            Date limite de dépôt : <strong>{campagne.libelle_cloture}</strong>
          </div>
        )}
      </div>
      <div className="trust-strip">
        🔒 Connexion sécurisée — Données chiffrées et confidentielles — INSAPT / Gouvernement du Tchad
      </div>
    </aside>
  );
};

const SiteFooter = () => (
  <footer className="site-footer">
    <ul>
      <li><span aria-hidden="true">🔒</span> Plateforme officielle sécurisée</li>
      <li><span aria-hidden="true">✅</span> Données protégées &amp; confidentielles</li>
      <li><span aria-hidden="true">🏛️</span> INSAPT — Gouvernement du Tchad</li>
    </ul>
  </footer>
);

export default SiteFooter;
